import { trans } from "utils/helpers";
import "./style.scss";
import { MessageType } from "types/enum";

function Toast(
  massage: any = "",
  messageType:
    | MessageType.confirm
    | MessageType.confirmDelete
    | MessageType.error
    | MessageType.info
    | MessageType.noDialog
    | MessageType.success
    | MessageType.warning,
  yesFunc?: any,
  data?,
  noFunc?
) {
  const timeID = new Date().getTime() + "toast";
  let node;
  let showDataFlag = false;
  let timeoutId;
  let startTime;
  let remainingTime = 6000;
  let paused = false;
  const toastStyle =
    messageType == MessageType.error
      ? "error"
      : messageType == MessageType.success
      ? "success"
      : messageType == MessageType.warning
      ? "warning"
      : messageType == MessageType.info
      ? "info"
      : messageType == MessageType.confirm
      ? "warning"
      : "error";

  const toastBackgroundColor =
    messageType == MessageType.error
      ? "danger"
      : messageType == MessageType.success
      ? "success"
      : messageType == MessageType.warning
      ? "warning"
      : messageType == MessageType.info
      ? "info"
      : messageType == MessageType.confirm
      ? "warning"
      : "danger";

  const customColor =
    messageType == MessageType.error
      ? "#dc3545"
      : messageType == MessageType.success
      ? "#198754"
      : messageType == MessageType.warning
      ? "#ffc107"
      : messageType == MessageType.info
      ? "#0dcaf0"
      : messageType == MessageType.confirm
      ? "#ffc107"
      : "#dc3545";


      
  const handleClick = (event) => {
    if (
      messageType == MessageType.success &&
      event.target !== document.getElementById(timeID) && !data
    ) {
      document.getElementById("backScreen")?.remove();
      document.getElementById(timeID)?.remove();
    }
    document.removeEventListener("click", handleClick);
  };
  document.addEventListener("click", handleClick);

  const yes = () => {
    document.getElementById("backScreen")?.remove();
    document.getElementById(timeID)?.remove();
    if (yesFunc) {
      yesFunc();
    }
  };

  document.addEventListener("keydown", (e: any) => {

    if (e.key === "Tab") {
      if (!document.getElementById(timeID)?.contains(e.target as any)) {
        e.preventDefault();
      }
      if (e.target.className == "btn btn-danger  py-0 mx-2") {
        e.preventDefault();
      }
      if (e.target.className == "btn btn-outline-danger   py-0") {
        e.preventDefault();
      }

      const yesBtn = document.getElementById(timeID + "yes") as any;
      const noBtn = document.getElementById(timeID + "no") as any;
      if (e.target === yesBtn) {
        noBtn.focus();
        e.preventDefault(); // جلوگیری از حرکت پیش‌فرض Tab
      }
      // اگر فوکوس روی دکمه دوم باشد، به دکمه اول برویم
      else if (document.activeElement === noBtn) {
        yesBtn.focus();
        e.preventDefault(); // جلوگیری از حرکت پیش‌فرض Tab
      }
    }
  });

  setTimeout(() => {
    document.getElementById("progress")?.classList.add("active-progress");
  }, 10);

  const no = () => {
    document.getElementById("backScreen")?.remove();
    document.getElementById(timeID)?.remove();
    if (noFunc) {
      noFunc();
    }
  };



  const showData = (e) => {
    e.stopPropagation();
    const arrow = document.getElementById("arrow") as any;
    if (showDataFlag) {
       let heightChild = document.getElementById(timeID + "UL")
        ?.clientHeight as any;
            let parent = document.getElementById(timeID)?.scrollHeight as any;
   
      let e = document.getElementById(timeID + "UL");
      var child = e?.lastElementChild;
      while (child) {
        e?.removeChild(child);
        child = e?.lastElementChild;
      }
      showDataFlag = false;
      arrow?.classList?.remove("arrowTop");
    if( (document.getElementById(timeID)as any)){
      // (document.getElementById(timeID)as any).style.height=parent-heightChild+'px';
      (document.getElementById('side-section')as any).style.height=parent-heightChild+'px'
    }
    } else {
      let dataList2 = data.map((item, index) => {
        return `<div class='${item.MessagemessageType}toast'>
                    ${trans(item.Message)
                      ?.replaceAll("\\n", "<br/>").replaceAll("\n", "<br/>")
                      ?.replaceAll("n\\", "<br/>")
                      ?.replaceAll("\\\n", "<br/>")}
                        ${(typeof item?.Data!='string' && !!item?.Data?.length) ? item?.Data?.map((item1)=>{//برای لول سوم ارور
                        return `<div class='${item1.MessagemessageType}toast'>(
                         ${item1.Message?trans(item1.Message)
                      ?.replaceAll("\\n", "<br/>").replaceAll("\n", "<br/>")
                      ?.replaceAll("n\\", "<br/>")
                      ?.replaceAll("\\\n", "<br/>"):''}
                         )</div>`
                      }):''}
                    <br>
                   ${index !== data.length - 1 ? "-----------" : ""} 
                </div>`;
      });
      document
        .getElementById(timeID + "UL")
        ?.insertAdjacentHTML("beforeend", `${dataList2.join("")}`);
      showDataFlag = true;
      arrow.classList.add("arrowTop");
       let parent = document.getElementById(timeID)?.scrollHeight as any;
      let sideSection = document.getElementById("side-section") as any;
      if (sideSection?.style) {
        sideSection.style.height = parent + "px";
      }
    }
    if(messageType==MessageType.confirm || messageType==MessageType.confirmDelete){

      let toastContainer=document.getElementsByClassName('toastContainer')[0] as any
      toastContainer.style.overflowY='auto'
    }  
  };
  const tanslatedText = trans(
    massage == undefined ? "msg_serverexceptionerror" : massage
  );

  if (
    messageType != MessageType.confirm &&
    messageType != MessageType.confirmDelete 
  ) {
    if (data) {
      node = `
        <div id=${timeID} class='${toastStyle}toast toastData posotion-relative  alert alert-${toastBackgroundColor} text-dark border-0 '>
        
        <div class="w-100 pt-1 mb-0 d-flex justify-content-end">
        <span class='hidetoast'  id=${timeID + "close"}>&#10006;</span>
        </div>
        <div class='headerToast mb-0'>
        <div class="d-flex justify-content-start align-items-center px-2">
        <div style="width:4%">
        <svg xmlns="http://www.w3.org/2000/svg" width="100%"  fill="${customColor}" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
                </svg>
                </div>
                <p style="width:95%;word-wrap: break-word;font-weight:700  " class="mx-2 my-0  d-flex justify-content-start align-items-center h-100">
                ${tanslatedText
                  .replaceAll("\\n", "<br/>").replaceAll("\n", "<br/>")
                  .replaceAll("n\\", "<br/>")}
              </p>
              </div>
              </div>
          <div id=${
            timeID + "UL"
          } class="px-2 mt-1 w-75" style="word-wrap: break-word;">

          </div>
          <div class='showtoast d-flex' id=${
            timeID + "show"
          }><div style='font-weight:500'>جزئیات</div><div id="arrow" class="detailArrow">&#8250;</div>
          </div>
            <div id='side-section' style="position:absolute;width:8px;background-color:${customColor};top:0px;right:0px;"></div>

        </div>`;
    } else {
   
      node = `

      <div id=${timeID} class='${toastStyle}toast new p-2 posotion-relative  alert alert-${toastBackgroundColor} text-dark border-0  '>
      <div class="w-100 pt-1 mb-0 d-flex justify-content-end">
       <span class='hidetoast'  id=${timeID + "close"} >&#10006;</span>
       </div>
      <div class='toast-container newcontain text-end w-100 px-2' style="max-height:200px;overflow-y:auto">
        <div class='toast-container__content position d-flex justify-content-start align-items-center  '>
          <div style="width:7%"> <svg xmlns="http://www.w3.org/2000/svg" width="100%"  fill="${customColor}" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
                </svg></div>
            <p style="width:92%;word-wrap: break-word;font-weight:700" class='mx-2 my-0  d-flex justify-content-start align-items-center h-100'>
            ${tanslatedText
              .replaceAll("\\n", "<br/>").replaceAll("\n", "<br/>")
              .replaceAll("\n", "<br/>")}
            </p>
        
        </div>
       
          <div style="position:absolute;width:8px;background-color:${customColor};top:0px;right:0px;height:100%"></div>

          <div id="progress" class="progress-section" style="position:absolute;height:4px;background-color:${customColor};bottom:-1px;right:0px"></div>
    </div> `;
    }
  } else {
    node = `
  <div id=${timeID} class='${toastStyle}toast alerttoast   new posotion-relative alert  alert-${toastBackgroundColor} text-dark border-0 h-100'>
    <div class='headerToast newHead d-flex  px-3 py-2 w-100' style="justify-content:flex-end">
      <span class="hidetoast "   id=${timeID + "close"}>&#10006;</span> 
    </div>
    <div class='toastContainer pb-0' style="overflow-y:auto">
   <div class='toastContainer__content d-flex justify-content-start align-items-center pt-1'>
      
        <div class="d-flex justify-content-start align-items-start px-1">
              <div style="width:7%">     ${
                messageType == MessageType.confirmDelete
                  ? `<svg xmlns="http://www.w3.org/2000/svg" width="100%"  fill="#dc3545" class="bi bi-trash3-fill" viewBox="0 0 16 16">
                  <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5"/>
                </svg>`
                  : `<svg xmlns="http://www.w3.org/2000/svg" width="100%"  fill="#ffc107" class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
  <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
</svg>`
              }</div>
                <p style="width:92%;word-wrap: break-word;font-weight:700  " class="mx-2 my-0  d-flex justify-content-start align-items-center h-100">
                ${tanslatedText
                  .replaceAll("\\n", "<br/>").replaceAll("\n", "<br/>")
                  .replaceAll("n\\", "<br/>")}
              </p>
              </div>
        </div>

         <div class='toastContainer__footer  d-flex justify-content-end mt-3 mb-1'>
          <button class='btn btn-${
            messageType == MessageType.confirmDelete ? "danger" : "warning"
          }  py-0 mx-2' id=${timeID + "yes"}
          style='font-size:14px'
          >${trans("yes")}</button>
          <button   class='btn btn-outline-${
            messageType == MessageType.confirmDelete
              ? "danger"
              : "warning text-dark"
          }   py-0' id=${timeID + "no"} 
        style='font-size:14px'
          >${trans("no")}</button>
        </div>

       ${
         data
           ? `<div id=${
               timeID + "UL"
             } class="px-2" style='word-wrap: break-word;'></div>
          <div class='showtoast row justify-content-center' id=${
            timeID + "show"
          } class="mt-1">
          <div class="col-auto p-0" style='font-weight:500'>جزئیات</div>
          <div id="arrow" class="detailArrow p-0">&#8250;</div>`
           : ""
       }
            
    </div>   
    
      <div id='side-section' style="position:absolute;width:8px;background-color:${customColor};top:0px;right:0px;height:100%"></div>

  </div>`;

    //     else {
    //       node = `
    //     <div id=${timeID} class='${toastStyle}toast alerttoast  new posotion-relative alert alert-${messageType==MessageType.confirmDelete?'danger':'warning'}text-dark border-0 h-100'>
    //       <div class='headerToast newHead d-flex justify-content-end p-2 w-100'>
    //        <span class="hidetoast "   id=${
    //                 timeID + "close"
    //               }>&#10006;</span>

    //       </div>
    //       <div class='toastContainer pb-2'>
    //       <div class="d-flex justify-content-start align-items-center px-2">
    //                 ${messageType==MessageType.confirmDelete? `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#dc3545" class="bi bi-trash3-fill" viewBox="0 0 16 16">
    //                   <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5"/>
    //                 </svg>`:`<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#ffc107" class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
    //   <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
    // </svg>`}
    //                 <p style="word-wrap: break-word;font-weight:700  " class="mx-2 my-0  d-flex justify-content-start align-items-center h-100">
    //                 ${tanslatedText.replaceAll("\\n", "<br/>").replaceAll(
    //                   "n\\",
    //                   "<br/>"
    //                 )}
    //               </p>
    //               </div>
    //         <div class='toastContainer__footer mt-3 d-flex justify-content-end'>
    //           <button  class='btn btn-${messageType==MessageType.confirmDelete?'danger':'warning'} text-dark py-0 mx-2' id=${
    //             timeID + "yes"
    //           } style='font-size:14px'>${trans("yes")}</button>
    //           <button class='btn btn-outline-${messageType==MessageType.confirmDelete?'danger':'warning'}  text-dark py-0' id=${
    //             timeID + "no"
    //           }
    //         style='font-size:14px'
    //           >${trans("no")}</button>
    //         </div>
    //       </div>

    //   <div id='side-section' style="position:absolute;width:8px;background-color:${messageType==MessageType.confirmDelete?'#dc3545':'#ffc107'};top:0px;right:0px;height:100%"></div>

    //     </div>`;
    //     }
  }

  let toastEl = document.getElementById("tostErroreBox");
  let add = false;

  if (
    messageType == MessageType.confirm ||
    messageType == MessageType.confirmDelete
  ) {
    if (!document.getElementsByClassName("alerttoast").length) {
      toastEl?.insertAdjacentHTML("afterbegin", node);
      add = true;
    }
  } else {
    toastEl?.insertAdjacentHTML("afterbegin", node);
    add = true;
  }

  if (
    messageType == MessageType.confirm ||
    messageType == MessageType.confirmDelete
  ) {
    if (add) {
      document
        .getElementById("DashboardLayout")
        ?.insertAdjacentHTML(
          "afterbegin",
          '<div id="backScreen" class="fullScreen" ></div>'
        );
      document
        .getElementById(
          timeID + (MessageType.confirmDelete === messageType ? "no" : "yes")
        )
        ?.focus();
      document.getElementById(timeID + "yes")?.addEventListener("click", yes);
      document.getElementById(timeID + "no")?.addEventListener("click", no);
      document.getElementById(timeID + "close")?.addEventListener("click", no);
      document
        .getElementById(timeID + "show")
        ?.addEventListener("click", showData);
    }
  } else {
    if (data) {
      document
        .getElementById(timeID + "show")
        ?.addEventListener("click", showData);
    }
    document.getElementById(timeID + "close")?.addEventListener("click", no);
  }
  if (
    messageType != MessageType.confirm &&
    messageType != MessageType.confirmDelete
  ) {
    if (data) {
      //  setTimeout(()=>{
      //  document.getElementById(timeID)?.remove()
      //
      //  }, 5000)
      //
    } else {

const startTimer=() =>{
    startTime = Date.now();
    timeoutId =  setTimeout(() => {
        document.getElementById(timeID)?.remove();
      }, remainingTime);;
    paused = false;
  }

  const pauseTimer=()=> {
    if (!paused) {
    console.log(document.getElementById("progress")?.clientWidth);
    
        if((document.getElementById("progress")?.style as any)){

  (document.getElementById("progress")?.style as any).width=document.getElementById("progress")?.clientWidth+'px'
        }

      clearTimeout(timeoutId);
      const elapsed = Date.now() - startTime;
      remainingTime -= elapsed;
      paused = true;
      console.log("Paused with", remainingTime, "ms left");
    }
  }

  const resumeTimer=()=> {
    if (paused) {
      if((document.getElementById("progress")?.style as any)){

        (document.getElementById("progress")?.style as any).width='100%';
        (document.getElementById("progress")?.style as any).transition=`width ${remainingTime}ms linear`;

      }
        


      startTimer();
      console.log("Resumed");
    }
  }


        startTimer();
        document.getElementById(`${timeID}`)?.addEventListener("mouseenter", pauseTimer);
document.getElementById(`${timeID}`)?.addEventListener("mouseleave", resumeTimer);
    }
 
    if(document.getElementById(`side-section`)){


      (document.getElementById(`side-section`)as any).style.height=document.getElementById(`${timeID}`)?.scrollHeight+'px'
    }





  // Start the timer initially







  
}

  /*   let list:any = document.getElementById("tostErroreBox")
  
    while (list && list.hasChildNodes()) {
      setInterval( list.removeChild(list.firstChild), 5000);
    }
    */
}

function ToastShow() {
  return <div id={"tostErroreBox"} className={"errorBox"}></div>;
}

export { ToastShow, Toast };
